module.exports = __webpack_public_path__ + "43fa71bbde78ddbc57dd094c75525d09.svg";